import React, { Component } from 'react';
import Social from './social';
import ProductList from './product-list';
import Subscribe from '../form/subscribe';

export default class Footer extends Component {
  render () {
    let {T} = this.props
    return (
      <footer>
        <div className='wrapper'>
          <ProductList T={T}/>
        </div>
        { this.props.disableSocial ? <div/> : <Social url={window.location.href} text={T.translate('title')}/> }
        { (this.props.disableSubscribe || !this.props.mailchimpUrl) ? <div/> : <Subscribe action={this.props.mailchimpUrl}/> }
        <div className='footer-bottom-wrapper'>
          <div className='footer-bottom'>
            <nav>
              <a href={T.translate('footer.about-href')} rel='noopener noreferrer' target='_blank'><T.text text={"footer.about"}/></a>
              <a href={T.translate('footer.twitter-href')} rel='noopener noreferrer' target='_blank'><T.text text={"footer.twitter"}/></a>
              <a href={T.translate('footer.company-href')} rel='noopener noreferrer' target='_blank'><T.text text={"footer.company"}/></a>
              <a href={T.translate('footer.privacy-href')} rel='noopener noreferrer' target='_blank'><T.text text={"footer.privacy"}/></a>
              <a href={T.translate('footer.support-href')}><T.text text={"footer.support"}/></a>
            </nav>
            <span>&#169; i3DESIGN Co., Ltd.</span>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/footer.js